
(function(){

  var acc = document.getElementsByClassName("accordion");
  var i;
  const accordionTitles = document.querySelectorAll(".accordion");
  
  if (document.location.pathname.indexOf('/account') > -1 || document.location.pathname.indexOf('/blogs') > -1 || document.location.pathname.indexOf('/pages/faqs') > -1) {
    var height = false;
  }else if(document.location.pathname.indexOf('/pages/about') > -1){
    var height = true;
    let activeImage = document.querySelector('.stockist-swiper .swiper-slide-active img');
    if(activeImage) {
      let imageHeight = activeImage.offsetHeight;
      document.querySelector('.sub-page__image.stockist-swiper').style.maxHeight = imageHeight;
    }
  }else{
    var height = true;
  }

  const swiper = new Swiper('.sub-page-content__wrapper', {
    spaceBetween: 15,
    slidesPerView: 1,
    speed: 1,
    autoHeight: height,
    allowTouchMove: false,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    }
  });

  
  let currentButton;

  let swiperButton = document.getElementsByClassName('sub-page-navigation-element__button');
  for(let i = 0; i < swiperButton.length; i++) {
    if(i == 0){
      let button = swiperButton[0];
      let offsetL = button.offsetLeft;
      let offsetW = button.offsetWidth;
      document.querySelector('.slider').style.left = offsetL + 'px';
      document.querySelector('.slider').style.width = offsetW + 'px';
      currentButton = button;
    }
    swiperButton[i].onclick = function() {

      /* Define the variables
        * 'button' allows us to simplify repeating 'swiperButton[i]'
        * 'slideNo' gets us the slide number from the dataset
        * 'current' assists with getting the current 'active' button.
      */
      let button = swiperButton[i];
      let slideNo = button.dataset.slide;
      let current = document.getElementsByClassName("active");

      currentButton = button;
      
      let offsetL = button.offsetLeft;
      let offsetW = button.offsetWidth;
      document.querySelector('.slider').style.left = offsetL + 'px';
      document.querySelector('.slider').style.width = offsetW + 'px';
      
      // Set/remove 'active' class from button and its siblings.
      current[0].className = current[0].className.replace(" active", "");
      this.className += " active";

      if (document.location.pathname.indexOf('/blogs') > -1) {
        slideNo = slideNo;
      }else{
        // Subtract '1' from the index due to SwiperJS index offset.
        slideNo = slideNo - 1;
      }

      // Slide 'swiper' to the selected slide.
      swiper.slideTo(slideNo);
    };
  }
  
  window.addEventListener('resize', function(){
    let offsetL = currentButton.offsetLeft;
    let offsetW = currentButton.offsetWidth;
    document.querySelector('.slider').style.left = offsetL + 'px';
    document.querySelector('.slider').style.width = offsetW + 'px';
  });

  const stockistSwiper = new Swiper('.stockist-swiper', {
    spaceBetween: 0,
    slidesPerView: 1,
    autoHeight: false,
    speed: 1,
    breakpoints: {
      768: {
        direction: 'vertical',
        allowTouchMove: false,
      }
    },
    on: {
      init: function () {
        
        if (window.matchMedia("(min-width: 990px)").matches) {
          let imageHeight = document.querySelector('.stockist-swiper .swiper-slide-active img').height;
          document.querySelector('.stockist-swiper').style.maxHeight = imageHeight + "px";
          document.querySelector('.stockist-swiper').style.marginBottom = "30px";
        }
        
      }
    }
  });

  if (window.location.hash.indexOf("stockists") > -1) {
    document.querySelector('[data-slide="2"]').click();
    if (window.matchMedia("(min-width: 990px)").matches) {
      let imageHeight = document.querySelector('.stockist-swiper .swiper-slide-active img').height;
      document.querySelector('.stockist-swiper').style.maxHeight = imageHeight + "px";
      document.querySelector('.stockist-swiper').style.marginBottom = "30px";
    }
  }

  let sliderSub = document.querySelectorAll('.sub-page-swiper');
  for (i = 0; i < sliderSub.length; i++) {
    const swiperSubPage = new Swiper(sliderSub[i], {
      spaceBetween: 15,
      slidesPerView: 1,
      autoHeight: true,
      mousewheel: {
        releaseOnEdges: true,
      },
      freeMode: true,
      breakpoints: {
        768: {
          direction: 'vertical',
        }
      }
    });
  }

  /*for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {

      for(j = 0; j < acc.length; j++) {
        acc[j].nextElementSibling.style.maxHeight = null;
      }
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      panel.style.maxHeight = panel.scrollHeight + "px";  



      setTimeout(() => {
        swiper.updateAutoHeight();
      }, 200)

      if(this.classList.contains('is-content-accordion')){
        let slideNo = this.getAttribute('data-contentslide');
        // Slide 'swiper' to the selected slide.
        stockistSwiper.slideTo(slideNo);
        swiper.updateSize();
      }

    });
  }*/

  if (document.location.pathname.indexOf('/account') > -1 || document.location.pathname.indexOf('/blogs') > -1 || document.location.pathname.indexOf('/pages/faqs') > -1) {
    
  }else{
    

  }

  accordionTitles.forEach((accordionTitle) => {
    accordionTitle.addEventListener("click", () => {
      if (accordionTitle.classList.contains("active")) {
        accordionTitle.classList.remove("active");
      } else {
        const accordionTitlesWithIsOpen = document.querySelectorAll(".sub-page__content .active");
        accordionTitlesWithIsOpen.forEach((accordionTitleWithIsOpen) => {
          accordionTitleWithIsOpen.classList.remove("active");
        });
        accordionTitle.classList.add("active");
        setTimeout(() => {
          swiper.updateAutoHeight();
        }, 200)
  
        if(accordionTitle.classList.contains('is-content-accordion')){
          let slideNo = accordionTitle.getAttribute('data-contentslide');
          // Slide 'swiper' to the selected slide.
          stockistSwiper.slideTo(slideNo);
          swiper.updateSize();
        }
      }
    });
  });

  
})()